import styled, { css } from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;
export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;
export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;
export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const OuterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  font-weight: bold;
`;
export const RowTitleText = styled.h2`
  color: #474747;
  font-size: 28px;
  font-family: lato;
  text-transform: initial;
  margin-bottom: 10px;
  line-height: 1;
  margin-top: -3px;
  font-weight: bold;
`;
export const WrapperStatus = styled.div`
  justify-self: end;
`;

export const ContactDetail = styled.div`
  margin-left: -137px;
  width: 208%;
`;

export const ButtonData = styled(BaseButton)`
  background: #05719a;
  border: 1px solid #05719a;
  font-weight: normal;
  width: auto;
  margin-right: 5px;
  font-size: 14px;
  font-family: lato;
`;
export const CompanyDetail = styled.div`
  justify-self: end;
  font-size: 14px;
  font-style: italic;
  margin-bottom: 10px;
`;

export const ActiveButton = styled(BaseButton)`
  background: #368939;
  border: 1px solid #368939;
  font-weight: normal;
`;

export const InActiveButton = styled(BaseButton)`
  background: #e83f1e;
  border: 1px solid #e83f1e;
  font-weight: normal;
`;

export const PendingButton = styled(BaseButton)`
  background: #ff5101;
  border: 1px solid #ff5101;
  font-weight: normal;
`;

export const CommunicationDetail = styled.div`
  margin-top: 25px;
`;

export const EmailDetail = styled.div`
  margin-bottom: 15px;
  color: #000000;
  text-decoration-line: underline;
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
`;

export const PhoneDetail = styled.div`
  margin-bottom: 15px;
  color: #000000;
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
`;
export const CommunicationOuterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-weight: bold;
`;

export const PlatformNotExist = styled.div`
  color: #cccccc;
`;
export const PlatformExist = styled.div`
  color: #004c7f;
`;
export const EditorDescription = styled.div`
  color: #767676;
  margin: 0;
  line-height: 1;
  font-size: 16px;
  padding-left: 10px;
  margin-top: 5px;
  font-size: 14px;
  font-family: lato;
  font-style: normal;
`;
export const EditorDescriptionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  font-weight: normal;
  margin-top: 10px;
`;
export const EditorDescriptionTitle = styled.div`
  justify-self: auto;
  color: #15aee5;
  font-weight: bold !important;
`;
